import { render, staticRenderFns } from "./SuspiciousProtocolsList.vue?vue&type=template&id=30bef472"
import script from "./SuspiciousProtocolsList.vue?vue&type=script&lang=js"
export * from "./SuspiciousProtocolsList.vue?vue&type=script&lang=js"
import style0 from "./SuspiciousProtocolsList.vue?vue&type=style&index=0&id=30bef472&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30bef472')) {
      api.createRecord('30bef472', component.options)
    } else {
      api.reload('30bef472', component.options)
    }
    module.hot.accept("./SuspiciousProtocolsList.vue?vue&type=template&id=30bef472", function () {
      api.rerender('30bef472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SuspiciousProtocolsList.vue"
export default component.exports